(function () {
  'use strict';

  var SECTION_KEY = '17844146307f74c935';

  function mobile() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  function imp(el, prop, value) {
    if (el && el.style) el.style.setProperty(prop, value, 'important');
  }

  function text(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function rect(el) {
    if (!el || !el.getBoundingClientRect) return null;
    var r = el.getBoundingClientRect();
    return r && r.width && r.height ? r : null;
  }

  function roots() {
    var out = [];
    var queue = [document];
    var seen = [];

    while (queue.length) {
      var root = queue.shift();
      if (!root || seen.indexOf(root) !== -1) continue;
      seen.push(root);
      out.push(root);
      if (!root.querySelectorAll) continue;

      root.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot && seen.indexOf(el.shadowRoot) === -1) queue.push(el.shadowRoot);
        if (el.tagName === 'IFRAME') {
          try {
            if (el.contentDocument && seen.indexOf(el.contentDocument) === -1) queue.push(el.contentDocument);
          } catch (e) {}
        }
      });
    }
    return out;
  }

  function exact(root, value) {
    if (!root || !root.querySelectorAll) return null;
    var wanted = value.toLowerCase();
    var best = null;
    root.querySelectorAll('button,[role="button"],label,a,span,p,div').forEach(function (el) {
      if (text(el).toLowerCase() !== wanted) return;
      var r = rect(el);
      if (!r) return;
      var area = r.width * r.height;
      if (!best || area < best.area) best = { el: el, area: area };
    });
    return best ? best.el : null;
  }

  function common(a, b, max) {
    var list = [];
    var cur = a;
    var d = 0;
    while (cur && d++ <= max) {
      list.push(cur);
      cur = cur.parentElement;
    }
    cur = b;
    d = 0;
    while (cur && d++ <= max) {
      if (list.indexOf(cur) !== -1) return cur;
      cur = cur.parentElement;
    }
    return null;
  }

  function tightenChain(el, stop, levels) {
    var cur = el;
    var d = 0;
    while (cur && cur !== stop && d++ < levels) {
      var r = rect(cur);
      if (r && r.height < 120) {
        imp(cur, 'margin-top', '0');
        imp(cur, 'margin-bottom', '0');
        imp(cur, 'padding-top', '0');
        imp(cur, 'padding-bottom', '0');
        imp(cur, 'min-height', '0');
      }
      cur = cur.parentElement;
    }
  }

  function firstReviewCard(root, afterY) {
    var vw = document.documentElement.clientWidth || window.innerWidth || 375;
    var best = null;
    if (!root.querySelectorAll) return null;

    root.querySelectorAll('article,li,div').forEach(function (el) {
      var r = rect(el);
      if (!r || r.top < afterY - 3 || r.top > afterY + 360) return;
      if (r.width < vw * 0.70 || r.height < 115 || r.height > 900) return;
      var t = text(el).toLowerCase();
      if (t.length < 20 || t.length > 2200) return;
      if (t.indexOf('filter images') !== -1 || t === 'recent') return;

      var st = window.getComputedStyle ? window.getComputedStyle(el) : null;
      var score = 0;
      if (/verified|etsy|read more|ago\b/.test(t)) score += 4;
      if (st) {
        if (parseFloat(st.borderRadius || '0') >= 6) score += 2;
        if (st.boxShadow && st.boxShadow !== 'none') score += 1;
        if (Math.max(parseFloat(st.borderTopWidth || '0'), parseFloat(st.borderRightWidth || '0'), parseFloat(st.borderBottomWidth || '0'), parseFloat(st.borderLeftWidth || '0')) > 0) score += 1;
      }
      if (score < 2) return;

      if (!best || r.top < best.r.top - 2 || (Math.abs(r.top - best.r.top) <= 2 && r.height < best.r.height)) {
        best = { el: el, r: r, score: score };
      }
    });
    return best;
  }

  function starRow(root, afterY, beforeY) {
    var vw = document.documentElement.clientWidth || window.innerWidth || 375;
    var best = null;
    if (!root.querySelectorAll) return null;

    root.querySelectorAll('button,[role="button"],div,section').forEach(function (el) {
      var r = rect(el);
      if (!r || r.top < afterY - 10 || r.bottom > beforeY + 18) return;
      if (r.height < 20 || r.height > 125 || r.width < 80 || r.width > vw * 0.98) return;

      var svgCount = el.querySelectorAll ? el.querySelectorAll('svg').length : 0;
      var starLabels = el.querySelectorAll ? el.querySelectorAll('[aria-label*="star" i],[title*="star" i]').length : 0;
      var buttonCount = el.querySelectorAll ? el.querySelectorAll('button,[role="button"]').length : 0;
      if (svgCount < 5 && starLabels < 5 && !(buttonCount >= 5 && svgCount >= 3)) return;
      if (svgCount > 14 || buttonCount > 14) return;

      var distance = Math.max(0, r.top - afterY);
      var area = r.width * r.height;
      if (!best || distance < best.distance - 2 || (Math.abs(distance - best.distance) <= 2 && area < best.area)) {
        best = { el: el, r: r, distance: distance, area: area };
      }
    });
    return best;
  }

  function compact(root) {
    if (!root || !root.querySelectorAll) return;

    var filter = exact(root, 'filter images');
    var recent = exact(root, 'recent');
    if (!filter || !recent) return;

    var fr = rect(filter);
    var rr = rect(recent);
    if (!fr || !rr || Math.abs(fr.top - rr.top) > 55) return;

    tightenChain(filter, null, 3);
    tightenChain(recent, null, 3);

    var row = common(filter, recent, 10);
    var rowRect = rect(row);
    if (row && rowRect && rowRect.height < 170) {
      imp(row, 'margin-top', '0');
      imp(row, 'margin-bottom', '-12px');
      imp(row, 'padding-top', '0');
      imp(row, 'padding-bottom', '0');
      imp(row, 'min-height', '0');
      imp(row, 'row-gap', '4px');
      imp(row, 'gap', '4px');
    }

    var controlBottom = Math.max(fr.bottom, rr.bottom);
    var card = firstReviewCard(root, controlBottom);
    if (!card) return;

    var star = starRow(root, controlBottom, card.r.top);
    if (!star) return;

    var starTarget = star.el.parentElement;
    var starTargetRect = rect(starTarget);
    if (!starTargetRect || starTargetRect.height > 170 || starTargetRect.width < star.r.width * 0.8) starTarget = star.el;

    var gap1 = Math.max(0, star.r.top - controlBottom);
    var pull1 = Math.min(30, Math.max(8, gap1 - 5));
    imp(starTarget, 'margin-top', '-' + pull1 + 'px');
    imp(starTarget, 'margin-bottom', '-8px');
    imp(starTarget, 'padding-top', '0');
    imp(starTarget, 'padding-bottom', '0');
    imp(starTarget, 'min-height', '0');
    imp(star.el, 'margin-top', '0');
    imp(star.el, 'margin-bottom', '0');
    imp(star.el, 'padding-top', '0');
    imp(star.el, 'padding-bottom', '0');
    imp(star.el, 'column-gap', '3px');
    imp(star.el, 'gap', '3px');

    var newStarRect = rect(star.el) || star.r;
    var gap2 = Math.max(0, card.r.top - newStarRect.bottom);
    var pull2 = Math.min(32, Math.max(8, gap2 - 6));
    imp(card.el, 'margin-top', '-' + pull2 + 'px');

    var cardParent = card.el.parentElement;
    var cp = rect(cardParent);
    if (cardParent && cp && cp.height < 1200) {
      var display = window.getComputedStyle ? window.getComputedStyle(cardParent).display : '';
      if (/grid|flex/.test(display || '')) {
        imp(cardParent, 'row-gap', '10px');
      }
    }

    if (row && row.setAttribute) row.setAttribute('data-cc-mobile-review-controls', 'compact');
    if (star.el.setAttribute) star.el.setAttribute('data-cc-mobile-review-stars', 'compact');
    if (card.el.setAttribute) card.el.setAttribute('data-cc-mobile-first-review', 'compact');
  }

  function run() {
    if (!mobile()) return;
    roots().forEach(function (root) {
      try { compact(root); } catch (e) {}
    });
  }

  function start() {
    run();
    [150, 400, 800, 1400, 2300, 3600, 5200, 8000].forEach(function (ms) {
      window.setTimeout(run, ms);
    });
    var count = 0;
    var timer = window.setInterval(function () {
      run();
      if (++count >= 16) window.clearInterval(timer);
    }, 700);
    window.addEventListener('orientationchange', function () { window.setTimeout(run, 250); });
    window.addEventListener('resize', run);
    if (window.MutationObserver && document.body) {
      new MutationObserver(function () { window.setTimeout(run, 0); }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
